export default __webpack_public_path__ + "static/media/planting.c5d241f9.jpg";